import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '@ohpen/enso-ui';

import { TranslationsList } from '@config/components';

export const TranslationsPage = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <Page>
      <Page.Title>{t('config.sections.translations')}</Page.Title>
      <Page.Content fill>
        <TranslationsList />
      </Page.Content>
    </Page>
  );
};
